export default __webpack_public_path__ + "static/media/loader.b808fde3.svg";